import React from "react";
import { motion } from "framer-motion";
import { Building2, HardHat, Pickaxe, TrendingUp, DollarSign } from "lucide-react";

const SubsectorDetail = ({ data }) => {
    if (!data) return null;

    const sectors = [
        { key: 'naics_236_building_construction', naics: "NAICS 236", icon: Building2, color: 'blue', label: 'Building Construction' },
        { key: 'naics_237_heavy_civil_engineering', naics: "NAICS 237", icon: Pickaxe, color: 'emerald', label: 'Heavy Civil & Engineering' },
        { key: 'naics_238_specialty_trade_contractors', naics: "NAICS 238", icon: HardHat, color: 'orange', label: 'Specialty Trade Contractors' }
    ];

    return (
        <div className="mt-12">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-gray-50 rounded-lg text-gray-600">
                    <TrendingUp size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">Construction Subsector Analysis (2026 Est.)</h3>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {sectors.map((sector, i) => {
                    const content = data[sector.key];
                    return (
                        <motion.div
                            key={i}
                            whileHover={{ y: -5 }}
                            className={`bg-white p-6 rounded-3xl shadow-sm border border-gray-100 border-t-4 border-t-${sector.color}-500`}
                        >
                            <div className="d-flex justify-content-between align-items-start mb-4">
                                <div className={`p-3 bg-${sector.color}-50 rounded-2xl text-${sector.color}-600`}>
                                    <sector.icon size={24} />
                                </div>
                                <div className={`px-2.5 py-1 bg-${sector.color}-50 text-${sector.color}-700 rounded-full text-[10px] font-bold border border-${sector.color}-100 shadow-sm`}>
                                    {sector.naics}
                                </div>
                                <div className="text-right">
                                    <p className="text-[10px] text-gray-400 font-bold uppercase m-0">Workforce Share</p>
                                    <p className={`text-lg font-black text-${sector.color}-600 m-0`}>{(content.workforce_share * 100).toFixed(0)}%</p>
                                </div>
                            </div>

                            <h4 className="text-md font-bold text-gray-900 mb-2">{sector.label}</h4>
                            {/* */}
                            <p className="text-xs text-gray-500 mb-4 h-10 overflow-hidden line-clamp-2">{content.primary_focus}</p>

                            <div className="space-y-3 pt-4 border-t border-gray-50">
                                <div className="d-flex justify-content-between">
                                    <span className="text-[10px] font-bold text-gray-400 uppercase">Employment</span>
                                    <span className="text-xs font-bold text-gray-700">{content.estimated_employment.toLocaleString()} jobs</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-[10px] font-bold text-gray-400 uppercase">Avg. Annual Wage</span>
                                    <span className="text-xs font-bold text-emerald-600">${content.average_annual_wage.toLocaleString()}</span>
                                </div>
                            </div>

                            <div className={`mt-4 p-3 bg-gray-50 rounded-xl`}>
                                <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Current Trend</p>
                                <p className="text-[11px] text-gray-700 m-0 italic font-medium">"{content.current_trend}"</p>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default SubsectorDetail;
